'use strict';

angular.module('far.insurance')
    .controller('InsuranceApplication2Controller', function($scope, $log, $timeout, $window, form, insuranceApplication) {
        var vm = {
            formInsuranceApplication2: form('formInsuranceApplication2'),
            form: {},
            constructor: function () {
                vm.form = insuranceApplication.new({});
                vm.form.type = 2;
                setTimeout(function () {
                    vm.addPerson2();
                }, 100);
            }
        };

        var formInsuranceApplication2_person = form('formInsuranceApplication2_person');
        formInsuranceApplication2_person
            .addField('full_name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'ФИО'
                }
            })
            .addField('birthday', 'dateDropdowns', {
                label_before: 'Дата рождения'
            })
            .addField('member_card', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Номер карты члена ФАР',
                    style: 'width: 350px;'
                }
            })
            .addField('position', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Должность'
                }
            })
            .addField('address', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Адрес регистрации (прописки)'
                }
            })
            .addField('passport', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Паспортные данные (серия, номер, когда и кем выдан)'
                }
            })

        vm.formInsuranceApplication2
            .addField('period_from', 'dateDropdowns', {
                validators: {
                    required: true
                },
                label_before: 'Период страхования с'
            })
            .addField('period_till', 'dateDropdowns', {
                validators: {
                    required: true
                },
                label_before: 'по'
            })
            .addField('insurance_sum', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    defaultOption: 'Страховая сумма, руб.',
                    class: 'form__item form__item_select width-300 margin_r_20'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, [
                {id: 1, name: '100 000'},
                {id: 2, name: '200 000'},
                {id: 3, name: '300 000'},
                {id: 4, name: '400 000'},
                {id: 5, name: '500 000'},
                {id: 6, name: '600 000'},
                {id: 7, name: '700 000'},
                {id: 8, name: '800 000'},
                {id: 9, name: '900 000'},
                {id: 10, name: '1 000 000'},
            ])
            .addField('persons_list', 'collection', {
                validators: {
                    required: true
                },
                label_before: 'Список лиц, подлежащих страхованию',
                buttons: {
                    add: 'Добавить лицо',
                    remove: 'Удалить'
                },
                fieldData: {
                    doDelete: function(item) {
                        item.deleted_at = new Date();
                    },
                    ngRepeat: 'item in model|filter:field.filterArray track by $index',
                    filterArray: function(item) {
                        return !item.deleted_at;
                    }
                }
            }, formInsuranceApplication2_person)
            .addField('email', 'text', {
                validators: {
                    required: true,
                    emailOnly: ''
                },
                options: {
                    placeholder: 'E-mail заявителя (на указанный e-mail придет информация о стоимости)'
                }
            });

        vm.addPerson2 = function () {
            if (! vm.formInsuranceApplication2.$fields.persons_list.model.length > 0)
                vm.formInsuranceApplication2.$fields.persons_list.addItem(vm.formInsuranceApplication2.$fields.persons_list.model);
        }

        vm.submit = function () {

            $log.debug(vm.form);

            vm.form.save()
                .then(function() {
                    $window.location.href = Routing.generate('insurance_index');
                })
                .catch(function(response) {
                    $log.error(response);
                    vm.alerts.push({
                        type: 'danger',
                        message: 'Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.'
                    });
                });
        }

        return vm;
    });